import { Component, OnInit } from "@angular/core";
import { Plugins } from '@capacitor/core';
const { SplashScreen } = Plugins;
//Services
import { LanguagesService } from 'src/app/services/languagesService/languages.service';
import { TagsService } from "src/app/services/tags/tags.service";

@Component({
  selector: "app-onboarding",
  templateUrl: "./onboarding.page.html",
  styleUrls: ["./onboarding.page.scss"],
})
export class OnboardingPage implements OnInit {

  constructor(
    public languageService: LanguagesService,
   ) {
  }
  ngOnInit() {
    if (!this.languageService.loadedLanguage) {
      const language = navigator.language == 'en-US' ? 'en' : 'es';
      this.languageService.loadLanguage(language);
    }
  }
  ionViewDidEnter() {
   setTimeout(()=>{
      SplashScreen.hide();
   },1500);
  }
  get gettextIUOnboarding() {
    if (this.languageService.textsIU) return this.languageService.textsIU.onboarding;
  }
}
